module.exports = __webpack_public_path__ + "img/百香果12.94652b77.png";